<style lang="stylus" scoped>
.v-alert {
  display: flex !important;
  margin: 0px;
  padding-left: 10%;
  padding-right: 10%;
}
</style>

<template>
  <div>
    <v-alert dense type="info" border="left" v-for="(notice, i) in notices" :key="i">
      {{ notice.noticeContent }}
    </v-alert>
    <br />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';

export default defineComponent({
  name: 'AppNoticeBanner',

  computed: {
    notices() {
      const userStore = useUserStore();
      return userStore.apis.learnerData._applicationNotices || [];
    }
  }
});
</script>
